import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Button from "../elements/Button";

const CountrySearch = (props) => {

	const inputEl = useRef(null);

	const handleCancel = event => {
	    event.preventDefault();
	    props.handleCancel();
    };

	return (
		<div className="country-search d-flex w-100 justify-content-center align-items-center mb-5">
			<label className="mr-3">{props.title}</label>
			<div className={`input-container d-flex position-relative mt-3 mt-lg-0 ${props.countryList.length > 0 ? 'has-results' : ''}`}>
				<input
					type="text"
					value={props.search}
					placeholder="Enter country here..."
					ref={inputEl}
					onChange={props.handleChange}
					onFocus={() => inputEl.current.select()}
				/>
				<div className="btn">Search</div>

                {props.handleCancel && props.search.length > 0 ? <a href="#" className="close" onClick={handleCancel}><img src="/images/icon-close-indigo.svg" alt="close" /></a> : ''}

				{props.countryList.length > 0 ?
					<div className="country-list">
						{props.countryList.map((item, key) => {
							return <a href="#" onClick={event => props.handleSelect(event, item, inputEl)} key={key}>{item.country}</a>
						})}
					</div>
                : ''}
			</div>
		</div>
	);

};


CountrySearch.propTypes = {
	title: PropTypes.string.isRequired,
	countryList: PropTypes.array.isRequired,
	search: PropTypes.string,
	handleChange: PropTypes.func.isRequired,
	handleSelect: PropTypes.func.isRequired,
	handleCancel: PropTypes.func
};

export default CountrySearch;


// WEBPACK FOOTER //
// ./resources/assets/js/components/CountrySearch.js